import React, { useContext, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { UserContext } from "./context/userContext";
import useToken from "./customHook/token";

const { Header, Content, Footer } = Layout;

export default function AppLayout() {
  const { token } = useToken();
  const { userDetails, getUserDetail, setUserDetails } =
    useContext(UserContext);
  const navigate = useNavigate();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleSignInSignOut = () => {
    if (userDetails) {
      localStorage.removeItem("accessToken");
      setUserDetails(null);
      navigate("/");
    } else {
      navigate("/Sign-In");
    }
  };

  useEffect(() => {
    getUserDetail(token);
  }, [token, getUserDetail]);

  const navItems = [
    {
      key: 1,
      label: <Link to="/">Home</Link>,
    },
    {
      key: 2,
      label: <Link to="Game">Game</Link>,
    },
    userDetails && {
      key: 3,
      label: <Link to="User-Profile">Profile</Link>,
    },
  ].filter(Boolean);

  return (
    <div>
      <Layout>
        <Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 24px",
            gap: "1rem",
          }}
        >
          <div className="logo text-lg font-bold text-white">Tenzies</div>
          <Menu
            theme="dark"
            mode="horizontal"
            items={navItems}
            style={{
              flex: 1,
              minWidth: 0,
            }}
          />
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {userDetails && (
              <span className="text-white hidden sm:inline">Hi, {userDetails.name}</span>
            )}
            <button
              type="button"
              onClick={handleSignInSignOut}
              style={{
                borderRadius: 999,
                border: "1px solid rgba(255, 255, 255, 0.3)",
                background: "rgba(255, 255, 255, 0.1)",
                color: "white",
                padding: "0.6rem 1rem",
                cursor: "pointer",
              }}
            >
              {userDetails ? "Sign Out" : "Sign In"}
            </button>
          </div>
        </Header>

        <Content
          style={{
            padding: "24px 48px",
          }}
        >
          <div
            style={{
              padding: 24,
              minHeight: 380,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Outlet />
          </div>
        </Content>

        <Footer
          style={{
            textAlign: "center",
            background: colorBgContainer,
          }}
        >
          Powered by AAROS ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </div>
  );
}
